const deploy = {
    deployEnvironment: '@@deploymentEnvironment@@',
};

export default deploy;
